import React from 'react';
import './DataBar.css';
import Total from './Components/Total/Total';
import Pending from './Components/Pending/Pending';
import InProgress from './Components/In-Progress/InProgress';
import Completed from './Components/Completed/Completed';
import Overdue from './Components/Overdue/Overdue';
import { isLegalEnvironment } from '../../../../../../AppSettings/environmentConfig';
import { TaskByEmployee } from '../../../../../../Models/Tasks/TaskModels';

type TableType = 'Tasks' | 'Checklist';

export interface DataBarProps {
  setActiveTable: (table: TableType) => void;
  activeTable: TableType;
  onStatusFilter: (status: string) => void;
  tasks?: TaskByEmployee[];
}

const DataBar = ({
  setActiveTable,
  activeTable,
  onStatusFilter,
  tasks = [],
}: DataBarProps) => {
  // Calculate counts from tasks data
  const totalCount = tasks.length;
  const pendingCount = tasks.filter(task => task.status === 'Pending').length;
  const inProgressCount = tasks.filter(task => task.status === 'In Progress').length;
  const completedCount = tasks.filter(task => task.status === 'Completed').length;
  
  // Calculate overdue tasks (tasks with due date in the past and status not completed)
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const overdueCount = tasks.filter(task => {
    if (!task.duedate || task.status === 'Completed') return false;
    const dueDate = new Date(task.duedate);
    dueDate.setHours(0, 0, 0, 0);
    return dueDate < today;
  }).length;

  return (
    <div className="data-bar-summary-cards">
      {isLegalEnvironment && (
        <div className="summary-card" onClick={() => onStatusFilter('Total')}>
          <Total count={totalCount} />
        </div>
      )}
      <div className="summary-card" onClick={() => onStatusFilter('Pending')}>
        <Pending count={pendingCount} />
      </div>
      <div className="summary-card" onClick={() => onStatusFilter('In Progress')}>
        <InProgress count={inProgressCount} />
      </div>
      <div className="summary-card" onClick={() => onStatusFilter('Overdue')}>
        <Overdue count={overdueCount} />
      </div>
      <div className="summary-card" onClick={() => onStatusFilter('Completed')}>
        <Completed count={completedCount} />
      </div>
    </div>
  );
};

export default DataBar;

